import { render, staticRenderFns } from "./TableRestoreSelected.vue?vue&type=template&id=07b1369a"
import script from "./TableRestoreSelected.vue?vue&type=script&lang=js"
export * from "./TableRestoreSelected.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports